<template>
  <v-snackbar
    v-model="visibilidadeStatus"
    class="mt-5 mr-1"
    :color="cor"
    top
    right
    :timeout="8000"
  >
    <template v-slot:action="{ attrs }">
      <v-btn
        icon
        small
        v-bind="attrs"
        @click="visibilidadeStatus = false"
      >
        <v-icon>clear</v-icon>
      </v-btn>
    </template>
    {{ descricao }}
  </v-snackbar>
</template>

<script>
export default {
  name: 'AppSnackbar',
  props: {
    visibilidade: Boolean,
    descricao: {
      type: String,
      default: '',
    },
    cor: {
      type: String,
      default: 'info',
    },
  },
  data() {
    return {
      visibilidadeStatus: false,
    };
  },
  watch: {
    visibilidade() {
      this.visibilidadeStatus = true;
    },
  },
};
</script>
